<template>
    <v-container class="report-body ma-0 pb-4">
        <booking-report
            :awaiting-report-download="awaitingReportDownload"
            @apply-filter="applyFilter"
            @download-report="exportReport"
        />
        <v-card class="mt-6">
            <v-card-text>
                <div class="d-flex flex-row justify-space-between">
                    <p class="table-title">Top 30 Hotéis</p>
                    <v-btn text :to="{name: 'hotelsReport'}" class="link-btn">
                        Relatório de Hotéis<v-icon small class="ml-2">mdi-arrow-right</v-icon>
                    </v-btn>
                </div>
                <hotel-report-table
                    ref="hotelReportTable"
                    :hide-footer="true"
                    :hide-query="true"
                    :limit="30"
                />
                <v-divider class="my-8"></v-divider>

                <div class="d-flex flex-row justify-space-between">
                    <p class="table-title">Top 10 Emissores</p>
                    <v-btn text :to="{name: 'emittersReport'}" class="link-btn">
                        Relatório de Emissores<v-icon small class="ml-2">mdi-arrow-right</v-icon>
                    </v-btn>
                </div>
                <emitter-report-table
                    ref="emitterReportTable"
                    :hide-footer="true"
                    :hide-query="true"
                    :limit="10"
                />
                <v-divider class="my-8"></v-divider>

                <div class="d-flex flex-row justify-space-between">
                    <p class="table-title">Top 10 Pontos de Venda</p>
                    <v-btn text :to="{name: 'pointsOfSaleReport'}" class="link-btn">
                        Relatório de Pontos de Venda<v-icon small class="ml-2">mdi-arrow-right</v-icon>
                    </v-btn>
                </div>
                <point-of-sale-report-table
                    ref="pointOfSaleReportTable"
                    :hide-footer="true"
                    :hide-query="true"
                    :limit="10"
                />
                <v-divider class="my-8"></v-divider>

                <div class="d-flex flex-row justify-space-between">
                    <p class="table-title">Top 30 Hóspedes</p>
                    <v-btn text :to="{name: 'guestsReport'}" class="link-btn">
                        Relatório de Hóspedes<v-icon small class="ml-2">mdi-arrow-right</v-icon>
                    </v-btn>
                </div>
                <guest-report-table
                    ref="guestReportTable"
                    :hide-footer="true"
                    :hide-query="true"
                    :limit="30"
                />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import ReportCards from "../../components/Reports/BookingReport/BookingReportResults.vue";
import FilterDrawer from "../../components/Reports/FilterDrawer.vue";
import HotelReportTable from "../../components/Reports/Tables/HotelReportTable.vue";
import EmitterReportTable from "../../components/Reports/Tables/EmitterReportTable.vue";
import PointOfSaleReportTable from "../../components/Reports/Tables/PointOfSaleReportTable.vue";
import GuestReportTable from "../../components/Reports/Tables/GuestReportTable.vue";
import BookingReport from "../../components/Reports/BookingReport/BookingReport.vue";
import { downloadFile, getFileNameWithSalt } from "../../services/DownloadFileService";
export default {
    name: "GeneralReport",

    components: {
        BookingReport,
        GuestReportTable,
        PointOfSaleReportTable,
        EmitterReportTable,
        HotelReportTable,
        FilterDrawer,
        ReportCards,
    },

    data: () => ({
        filter: {},
        awaitingReportDownload: false,
    }),

    methods: {
        applyFilter(filter) {
            this.filter = filter;
            this.$refs.hotelReportTable.getReportData(this.filter);
            this.$refs.emitterReportTable.getReportData(this.filter);
            this.$refs.pointOfSaleReportTable.getReportData(this.filter);
            this.$refs.guestReportTable.getReportData(this.filter);
        },

        async exportReport () {
            try {
                this.awaitingReportDownload = true;
                const response = await axios.get('/api/reports/booking/export', { params: this.getQueryParams(), responseType: 'blob' });
                downloadFile(response.data, getFileNameWithSalt('relatorio_reservas_partner_hub'), 'xls');
            } catch (error) {
                this.$simpleDialog('Ocorreu um erro ao baixar o relatório!', 'error');
            } finally {
                this.awaitingReportDownload = false;
            }
        },

        getQueryParams () {
            return {
                hotelId: this.filter.hotelId,
                pointOfSaleId: this.filter.pointOfSaleId,
                startDate: this.filter.startDate,
                finalDate: this.filter.finalDate,
            }
        },
    }
}
</script>

<style scoped>
.report-body {
    background: #f0f0f0;
    max-width: 100%;
    min-height: 100vh;
}

.table-title {
    font-size: 1.25rem;
    color: #333;
    font-weight: 500;
    margin-top: 16px;
    margin-bottom: 8px;
}

.link-btn {
    font-size: 12px;
    font-weight: normal;
}
</style>
